// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label {
  font-weight: bold;
}

.label-big {
  font-weight: 800;
}

.datetime {
  width: fit-content;
}

ion-popover {
  --width: auto;
}

ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
}

.summary-date-header {
  background-color: var(--ion-color-dark-shade);
  color: var(--ion-color-light);
}
.summary-date-header p {
  color: var(--ion-color-light) !important;
}

.summary-table-rows {
  border-bottom: 1px solid var(--ion-color-dark-shade);
}
.summary-table-rows ion-col {
  background-color: var(--ion-color-light);
  border-left: 1px solid var(--ion-color-dark-shade);
  text-transform: capitalize !important;
  padding: 3px 0 !important;
  padding-right: 10px !important;
}
.summary-table-rows .border-right {
  border-right: 1px solid var(--ion-color-dark-shade);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/account-summary/account-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,6CAAA;EACA,6BAAA;AACJ;AAAI;EACI,wCAAA;AAER;;AAEA;EASI,oDAAA;AAPJ;AADI;EACI,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,yBAAA;EACA,8BAAA;AAGR;AAEI;EACI,mDAAA;AAAR","sourcesContent":[".label {\r\n    font-weight: bold;\r\n}\r\n\r\n.label-big {\r\n    font-weight: 800;\r\n}\r\n\r\n.datetime {\r\n    width: fit-content;\r\n}\r\n\r\nion-popover {\r\n    --width: auto;\r\n}\r\n\r\nion-item {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n}\r\n\r\nion-datetime {\r\n    max-width: 100%;\r\n}\r\n\r\n.summary-date-header{\r\n    background-color: var(--ion-color-dark-shade);\r\n    color: var(--ion-color-light);\r\n    p{\r\n        color: var(--ion-color-light) !important;\r\n    }\r\n  }\r\n\r\n.summary-table-rows{\r\n    ion-col{\r\n        background-color: var(--ion-color-light);\r\n        border-left: 1px solid var(--ion-color-dark-shade);\r\n        text-transform: capitalize!important;\r\n        padding: 3px 0!important;\r\n        padding-right: 10px!important;\r\n    }\r\n\r\n    border-bottom: 1px solid var(--ion-color-dark-shade);\r\n\r\n    .border-right{\r\n        border-right: 1px solid var(--ion-color-dark-shade);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
